import { WmCloud } from "./public.api";

export function Login(usr, psw, redirect) {
  const cloud = new WmCloud("https://webmux.cloud/api/login", "https://webmux.cloud/api/register");
  let loginInstance = cloud.Login(usr, psw, redirect);
  return loginInstance;
}
